
import React from 'react';
import styled from 'styled-components';
import { isDesktop, isTab, plansPageContinueButtonFFlag } from '../utils/globalConfig';
import { Button } from "@vds/buttons";
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import { setPayGoMonthlyScenarios, updateSelectedPlanData } from '../../features/selectedData/selectedDataReducer';
import { useSelector, useDispatch } from 'react-redux';
const PrimaryButton = styled(Button)`
position: sticky ;
float:${isDesktop ? 'right' : 'none'};
bottom:7px;
z-index:7;
margin-bottom:20px;
left:${isTab ? '20%' : ''};
`;

const PaygoButton = ({ isPayGoScenariosWithMonthly, ctaLabel, selectedDeviceDetails }) => {

    const { planUpdatedData} = useSelector(state => state?.selectedReducer);
    const navigate = useNavigate();
     const dispatch = useDispatch();

   
    const handleButtonClick = () => {
        dispatch(setPayGoMonthlyScenarios(isPayGoScenariosWithMonthly));
         let updatedPlanData = JSON.parse(JSON.stringify(planUpdatedData));

        let currentPlandetails = selectedDeviceDetails?.currentPlanDetails;
       
        updatedPlanData = {
                "mtn": selectedDeviceDetails?.mtn,
                "formattedMtn": selectedDeviceDetails?.formattedMtn,
                "deviceImageUrl": selectedDeviceDetails?.deviceImageUrl,
                "deviceImageAlt": selectedDeviceDetails?.deviceImageAlt,
                "role": selectedDeviceDetails?.role,
                "deviceNickName": selectedDeviceDetails?.deviceNickName,
                "canadaMexicoCovered": selectedDeviceDetails?.canadaMexicoCovered,
                "recommendedOfferName": selectedDeviceDetails?.planRecommendationInfo?.planName,
                "mtnHashCode": selectedDeviceDetails?.mtnHashCode,
                "unlimitedUltimateFlag": selectedDeviceDetails?.unlimitedUltimateFlag,
                "brandName": selectedDeviceDetails?.brandName,
                "operatingSystem": selectedDeviceDetails?.operatingSystem,
                "featuresCart": [
                    {
                        "currentPlanId": currentPlandetails?.[0]?.planId,
                        "newPlanId": currentPlandetails?.[0]?.planId,
                        "currentPlanCategory": currentPlandetails?.[0]?.category,
                        "newPlanCategory": currentPlandetails?.[0]?.category,
                        "currentPlanName": currentPlandetails?.[0]?.planName,
                        "newPlanName": currentPlandetails?.[0]?.planName,
                        "planType": "land",
                        "quantity": "1",
                        "removePlan":"",
                        "currentPlanMonthly": "Y",
                        "monthlyPlan":"Y"
                    }
                ],
                "featuresConfirm": [
                    {
                        "currentPlanId": currentPlandetails?.[0]?.planId,
                        "newPlanId": currentPlandetails?.[0]?.planId,
                        "currentPlanCategory": currentPlandetails?.[0]?.category,
                        "newPlanCategory": currentPlandetails?.[0]?.category,
                        "currentPlanName": currentPlandetails?.[0]?.planName,
                        "newPlanName": currentPlandetails?.[0]?.planName,
                        "planType": "land",
                        "quantity": "1",
                        "removePlan": ""
                    }
                ],
                "updatedPlanDetails": [
                    {
                        "planName": currentPlandetails?.[0]?.planName,
                        "planCost": currentPlandetails?.[0]?.planCost,
                        "planType": "land",
                        "currentPlan": ""
                    }
                ],
                "effectiveDate": currentPlandetails?.[0]?.effectiveDate
            }
            

            dispatch(updateSelectedPlanData(updatedPlanData));
           
        if (selectedDeviceDetails?.skipCruiseAndFlightPlans) {
            navigate("/itpskipplan")
        } else {
            navigate("/itpcruiseplanselection")

        }
    }

    const DisplayChannel = () => {
        return (isTab ? '50%' : '100%')
    }

    return (
        <>{isPayGoScenariosWithMonthly && plansPageContinueButtonFFlag &&
            <PrimaryButton
                aria-label="Continue"
                size="large"
                data-testid="footerButton"
                width={isDesktop ? '30%' : DisplayChannel()}
                use={"primary"}
                onClick={() => handleButtonClick()}
            >{ctaLabel}
            </PrimaryButton>
        }
        </>

    )
}
PaygoButton.propTypes = {
    ctaLabel: PropTypes.string.isRequired,
    isPayGoScenariosWithMonthly: PropTypes.bool,
    selectedDeviceDetails: PropTypes.object,
}
export default PaygoButton;